import classNames from 'classnames';
import { ChevronRightIcon } from 'lucide-react';
import type { ElementType } from 'react';

import { Link } from '@/components/Link/Link';
import { slugify } from '@/util/strings/slugify';

import styles from './Byline.module.scss';

export function Byline({
    type,
    text,
    url,
    className,
    chipClassName,
    isHero = false,
    TagName = 'h3',
}: Byline.Props) {
    return (
        <div
            className={classNames(styles.chipWrapper, className, {
                [styles.hero]: isHero,
            })}
            data-byline={slugify(text)}
            data-byline-type={type}
        >
            {url ? (
                <TagName>
                    <Link
                        className={classNames(styles.chip, styles.link, chipClassName)}
                        href={url}
                    >
                        <Chip type={type} />
                        {text} <ChevronRightIcon className={styles.icon} />
                    </Link>
                </TagName>
            ) : (
                <TagName className={classNames(styles.chip, chipClassName)}>
                    <Chip type={type} />
                    {text}
                </TagName>
            )}
        </div>
    );
}

function Chip({ type }: Pick<Byline.Props, 'type'>) {
    if (type === 'new') {
        return (
            <span data-chip={type} className={styles.innerChip}>
                New
            </span>
        );
    }

    return null;
}

export namespace Byline {
    export interface Props {
        className?: string;
        chipClassName?: string;
        isHero?: boolean;
        text: string;
        url?: string;
        type?: 'new' | 'normal' | undefined;
        TagName?: ElementType;
    }
}
